import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

class DropdownSelect extends Component {
    render() {
        return (
            <Dropdown isOpen={this.props.dropdownOpen} direction="down" toggle={this.props.toggle} >
                <DropdownToggle caret>
                    {this.props.selectedSearchType}
                </DropdownToggle>
                <DropdownMenu>
                    {
                        this.props.dropdownValues.map(data => {
                            return (
                                <DropdownItem key={data} className="p-3" onClick={() => this.props.handleDropdown(data)}>{data}</DropdownItem>
                            )
                        })
                    }
                </DropdownMenu>
            </Dropdown>
        )
    }
}
export default DropdownSelect